import classNames from "classnames";
import { DateString } from "../../../../lib/api/models";
import styles from "./DateInput.module.css";
import StyledInput from "../StyledInput";
import {
  StyledInputLabelProps,
  StyledInputProps,
  StyledInputValidationProps,
} from "../StyledInput/StyledInput";

export type DateInputProps = StyledInputProps & {
  value: DateString;
  onChangeDate?: (date: DateString) => void;
  min?: DateString;
  max?: DateString;
};

type Props = DateInputProps &
  StyledInputLabelProps &
  StyledInputValidationProps;

export default function DateInput({
  inputClassName,
  onChangeDate,
  onChange,
  ...rest
}: Props) {
  return (
    <StyledInput
      {...rest}
      type="date"
      inputClassName={classNames(inputClassName, styles.input)}
      onChange={(event) => {
        onChange?.(event);
        onChangeDate?.(event.target.value as DateString);
      }}
    />
  );
}
